export const COLORS = {
  fire: { body: 0xf8863e, light: 0xffdf79 },
  ice: { body: 0x69d6e6, light: 0xe4fbff },
  lightning: { body: 0xc2a4ff, light: 0xfff2a4 },
} as const;
